/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { string, number, shape } from 'prop-types';
import { Typography, CardMedia, Link } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import { useIsMobile } from '../../../hooks/use-is-mobile';

export const RebateProduct = ({ product }) => {
  const { isMobile } = useIsMobile();

  if (!product?.sku) return null;

  const NO_IMAGE = 'https://assets.thdstatic.com/images/v1/no-img.svg';
  return (
    <div data-testid="rebate-product" className="sui-flex sui-py-4">
      <div data-testid="rebate-product-image" className="sui-mx-4 sui-max-h-[145px] sui-max-w-[145px]">
        <CardMedia
          src={product.imageUrl || NO_IMAGE}
          alt="Rebate Item Image"
          style={{ with: '145px', height: '145px' }}
          lazy
        />
      </div>
      <div
        className="sui-flex sui-flex-col sui-justify-around sm:sui-my-0 sui-my-4 sui-max-w-[100%] sm:sui-max-w-[50%]"
      >
        <Typography component="div">
          <Link
            href={product.detailsUrl}
            target={!isMobile ? '_blank' : ''}
            underline="none"
          >
            <span className="sui-font-bold sui-pr-1">{product.brand}</span>
            {product.shortName}
          </Link>
          <div className="sui-py-3">{product.infoLabel}</div>
          {product.detailsUrl && (
            <Link
              className="sui-flex sui-font-bold sui-justify-start sui-items-center sui-leading-normal"
              href={product.detailsUrl}
              target={!isMobile ? '_blank' : ''}
              rel="noreferrer"
            >
              View Product Details
              <ArrowForward size="small" color="brand" />
            </Link>
          )}
        </Typography>
      </div>
    </div>
  );
};

RebateProduct.displayName = 'RebateProduct';

RebateProduct.propTypes = {
  product: shape({
    brand: string,
    detailsUrl: string,
    displaySku: string,
    imageUrl: string,
    infoLabel: string,
    price: number,
    shortName: string,
    sku: string,
  }).isRequired,
};
